import React, { useState } from "react";
import {
    FiChevronDown,
    FiChevronUp,
    FiEdit,
    FiLock,
} from "react-icons/fi";

const UserRow = ({ user, onEdit, onPassword }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <tr className="border-t hover:bg-gray-50 transition bg-white">
                <td className="p-1 py-2 break-words text-x border border-gray-300">{user.userid | "Not Found"}</td>
                <td className="p-1 py-2 break-words text-x border border-gray-300">{user.name}</td>
                <td className="p-1 py-2 break-all whitespace-normal leading-relaxed border border-gray-300">{user.email}</td>
                <td className="p-1 py-2 border border-gray-300">{user.phone}</td>
                <td className="p-1 py-2 capitalize border border-gray-300">{user.role}</td>

                <td className="px-1 py-2 border border-gray-300">
                    <span
                        className={`px-2 py-1 rounded-full text-sm ${
                            user.status === "a"
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                        }`}
                    >
                        {user.status === "a" ? "Active" : "Inactive"}
                    </span>
                </td>

                <td className="p-4 flex gap-3 text-[11px]">
                    <button
                        onClick={() => onEdit(user)}
                         className="
                                flex items-center gap-2
                                bg-indigo-100
                                hover:bg-indigo-200
                                text-indigo-700
                                px-3 py-2
                                rounded-lg
                                
                                transition
                            "
                    >
                        <FiEdit /> Edit
                    </button>

                    <button
                        onClick={() => onPassword(user)}
                        className="
                                flex items-center gap-2
                                bg-orange-100
                                hover:bg-orange-200
                                text-orange-700
                                px-3 py-2
                                rounded-lg
                                
                                transition
                            "
                    >
                        <FiLock /> Password
                    </button>
                </td>
            </tr>
        </>
    );
};

export default UserRow;
